import { CLEAR_USER_FILTER, SET_USER_PAGE_NUMBER, SET_USERS_FILTER } from '../types';

export const setUserFilter = (organizationId) => ({
  type: SET_USERS_FILTER,
  payload: organizationId,
});

export const clearUserFilter = () => ({
  type: CLEAR_USER_FILTER,
})

export const setUserPageNumber = (pageNumber) => ({
  type: SET_USER_PAGE_NUMBER,
  payload: pageNumber ,
})